import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoRacaCor, cadastrarTipoRacaCor, alterarTipoRacaCor, excluirTipoRacaCor } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var TiposRacasCoresEditar = function () {
    var services = {
        getItem: getTipoRacaCor,
        cadastrarItem: cadastrarTipoRacaCor,
        alterarItem: alterarTipoRacaCor,
        excluirItem: excluirTipoRacaCor,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_RACAS_CORES, paginaPermissao: FUNCIONALIDADES.TIPOS_RACAS_CORES, rota: ROUTES.TIPOS_RACAS_CORES, services: services });
};
export default TiposRacasCoresEditar;
